var _circle, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.557 9.09001H17.8967L13.3917 22.4378C13.3454 22.575 13.2573 22.6942 13.1397 22.7786C13.0221 22.8631 12.881 22.9085 12.7362 22.9085H9.35888C9.2492 22.9085 9.14109 22.8824 9.0435 22.8324C8.94591 22.7823 8.86164 22.7097 8.79766 22.6206C8.73369 22.5315 8.69184 22.4285 8.67559 22.32C8.65934 22.2116 8.66915 22.1008 8.70422 21.9968L12.9014 9.56068C12.9477 9.42346 13.0358 9.30422 13.1535 9.21976C13.2711 9.13529 13.4122 9.09002 13.557 9.09001Z",
    fill: "url(#paint0_linear_724_1929)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8626 18.043H12.981C12.917 18.0429 12.8545 18.0621 12.8016 18.0981C12.7486 18.134 12.7078 18.1851 12.6843 18.2446C12.6608 18.3041 12.6558 18.3693 12.67 18.4317C12.6841 18.4941 12.7167 18.5508 12.7635 18.5945L17.1855 22.7218C17.3142 22.8419 17.4837 22.9087 17.6598 22.9086H21.5565L19.8626 18.043Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5562 9.08985C13.4098 9.08929 13.267 9.13555 13.1488 9.22188C13.0306 9.3082 12.943 9.43007 12.899 9.56968L8.7085 21.9853C8.67108 22.0897 8.65933 22.2014 8.67425 22.3112C8.68917 22.421 8.73031 22.5256 8.7942 22.6162C8.8581 22.7067 8.94285 22.7805 9.04131 22.8314C9.13976 22.8823 9.24902 22.9086 9.35983 22.9083H12.8243C12.9534 22.8853 13.074 22.8284 13.1738 22.7435C13.2737 22.6586 13.3492 22.5487 13.3927 22.425L14.2283 19.9622L17.2133 22.7463C17.3384 22.8498 17.4953 22.907 17.6577 22.9083H21.5398L19.8372 18.0427L14.8737 18.0438L17.9115 9.08985H13.5562Z",
    fill: "url(#paint1_linear_724_1929)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0986 9.55984C19.0524 9.42285 18.9643 9.30381 18.8469 9.21949C18.7294 9.13517 18.5885 9.08983 18.4439 9.08984H13.6074C13.752 9.08985 13.8929 9.13521 14.0104 9.21952C14.1278 9.30384 14.2159 9.42286 14.2621 9.55984L18.4594 21.9965C18.4945 22.1005 18.5043 22.2113 18.4881 22.3198C18.4719 22.4283 18.43 22.5313 18.3661 22.6205C18.3021 22.7096 18.2178 22.7822 18.1202 22.8323C18.0226 22.8824 17.9145 22.9085 17.8048 22.9085H22.6414C22.7511 22.9085 22.8592 22.8823 22.9568 22.8322C23.0544 22.7821 23.1387 22.7095 23.2026 22.6204C23.2666 22.5313 23.3084 22.4282 23.3246 22.3197C23.3408 22.2112 23.331 22.1004 23.2959 21.9965L19.0986 9.55984Z",
    fill: "url(#paint2_linear_724_1929)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_724_1929",
    x1: 15.1387,
    y1: 10.114,
    x2: 10.6319,
    y2: 23.4283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_724_1929",
    x1: 16.5457,
    y1: 16.3187,
    x2: 15.5032,
    y2: 16.6712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_724_1929",
    x1: 15.9719,
    y1: 9.72551,
    x2: 20.9191,
    y2: 22.9057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.6689df57262c6ba40f253b1a510183af.svg";
export { ForwardRef as ReactComponent };